import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Spacer } from '../../common/components/v2';
import { MIBCodebackDisplay } from '../detail/tasks/MIBCodebackDetail';
import { ITask } from '../tasks/interfaces/ITask';
import { MIBCodeback } from '../tasks/types/mibCodeback';

export const MIBCodebackDetail = ({ task }: { task: ITask }) => {
  const [expanded, setExpanded] = useState(false);
  const doExpand = () => setExpanded(!expanded);
  let status = 'Sending';
  if (task?.taskData && (task.taskData as MIBCodeback).updateResult) {
    status = 'Completed';
  }
  return (
    <Box pt={8}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        ml={-1}
      >
        <Box display="flex" flexDirection="row">
          <Box mt={-0.15} ml={-3.5} position="absolute">
            <IconButton
              style={{ width: '24px' }}
              size="small"
              onClick={doExpand}
            >
              <FontAwesomeIcon
                icon={faAngleRight}
                rotation={expanded ? 90 : undefined}
              />
            </IconButton>
          </Box>
          <Typography variant="h2">MIB CodeBack ({status})</Typography>
        </Box>
      </Box>
      <Spacer height={16} />
      {expanded && <MIBCodebackDisplay task={task} />}
    </Box>
  );
};
